"use client";
import {
  isBackdrop
} from "./MKDDWKFK.js";
import {
  walkTreeOutside
} from "./4SXGPXPS.js";
import {
  setAttribute
} from "./53CQGCDZ.js";

// src/dialog/utils/disable-accessibility-tree-outside.ts
function hideElementFromAccessibilityTree(element) {
  return setAttribute(element, "aria-hidden", "true");
}
function disableAccessibilityTreeOutside(id, elements) {
  const cleanups = [];
  const ids = elements.map((el) => el == null ? void 0 : el.id);
  walkTreeOutside(id, elements, (element) => {
    if (isBackdrop(element, ...ids))
      return;
    cleanups.unshift(hideElementFromAccessibilityTree(element));
  });
  const restoreAccessibilityTree = () => {
    for (const cleanup of cleanups) {
      cleanup();
    }
  };
  return restoreAccessibilityTree;
}

export {
  hideElementFromAccessibilityTree,
  disableAccessibilityTreeOutside
};
